<template>
  <div class="iframe-container">
    <iframe src="https://fantasylineups.com/iframe/index_props.html"></iframe>
  </div>
</template>

<script>
export default {
  name: "Mlbpropfinder",
};
</script>

<style lang="scss" scoped>
.iframe-container {
  position: relative;
  width: 100%;
  height: 100vh; /* Set the height to full viewport height */
}

.iframe-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
